module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-16 at 09.14.00.a7a53a70.png";